import { fade } from '@material-ui/core/styles/colorManipulator';
import { withStyles } from '@material-ui/core/styles';
import { signOut } from '../../store/actions/authActions';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { getSearchResults } from '../../store/selectors/searchResults';
import {
  searchByDisplayName,
  updateProfile
} from '../../store/actions/userProfileActions';
import { resetNotifications } from '../../store/actions/notificationsActions';

const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: 'white',
    [theme.breakpoints.up('sm')]: {
      minHeight: '70px'
    }
  },
  toolBar: {
    minHeight: '70px'
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginRight: theme.spacing.unit * 2,
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: '250px'
    }
  },
  searchIcon: {
    width: theme.spacing.unit * 9,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200
    }
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  hpIcon: {
    cursor: 'pointer',
    width: '210px'
  },
  profilePic: {
    width: '40px',
    borderRadius: '100px'
  },
  menuList: {
    width: '250px'
  },
  searchContainer: {
    width: '70%'
  },
  reactAutosuggestContainer: {
    position: 'relative',
    width: '70%',
    border: 'none',
    marginLeft: '50px',
    height: '50px'
  },
  reactAutosuggestInput: {
    width: '100%',
    height: '50px',
    padding: '10px 20px',
    border: 'none'
  },
  reactAutosuggestInputFocused: {
    outline: 'none'
  },
  reactAutosuggestInputOpen: {
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0'
  },
  reactAutosuggestSuggestionsContainer: {
    display: 'none'
  },
  reactAutosuggestSuggestionsContainerOpen: {
    display: 'block',
    position: 'absolute',
    top: '51px',
    width: '100%',
    border: '1px solid #aaa',
    backgroundColor: '#fff',
    fontSize: '16px',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    zIndex: '2',
    maxHeight: '400px',
    overflowY: 'scroll'
  },
  reactAutosuggestSuggestionsList: {
    margin: '0',
    padding: '0',
    listStyleType: 'none'
  },
  ReactAutosuggestSuggestion: {
    cursor: 'pointer',
    padding: '10px 20px'
  },
  reactAutosuggestSuggestionHighlighted: {
    backgroundColor: '#ddd'
  },
  popover: {
    width: '350px',
    maxHeight: '300px',
    overflowY: 'scroll',
    backgroundColor: '#ececf3'
  },
  notificationGrid: {
    padding: '8px',
    cursor: 'pointer',
    '&:hover': {
      background: '#bababf'
    }
  },
  notificationDate: {
    fontSize: '.8em'
  },
  circleImage: {
    objectFit: 'cover',
    borderRadius: '50%',
    width: '43px',
    height: '43px'
  },
  appbarOverlay: {
    position: 'absolute',
    top: '0',
    right: '0',
    width: '100%',
    height: '100%',
    background: 'gray',
    opacity: '.3',
    zIndex: '1000'
  },
  help: {
    color: '#233a54 !important',
    textDecoration: 'none !important'
  }
});

const mapStateToProps = state => {
  return {
    searchResults: getSearchResults(state),
    profile: state.firebase.profile,
    auth: state.firebase.auth,
    notifications: state.firestore.ordered.notifications
  };
};

const mapDispatchToProps = dispatch => {
  return {
    logOut: () => dispatch(signOut()),
    searchUsersHandler: (searchValue, influencerSearch) =>
      dispatch(searchByDisplayName(searchValue, influencerSearch)),
    resetUnreadMessagesHandler: () =>
      dispatch(updateProfile({ unReadMessages: 0 })),
    resetNotificationsHandler: () =>
      dispatch(resetNotifications({ unReadMessages: 0 }))
  };
};

export default compose(
  compose(
    connect(
      mapStateToProps,
      mapDispatchToProps
    ),

    withProps(({ auth, profile }) => ({
      profile,
      auth
    })),

    withStyles(styles)
  ),
  // Add props.router (used in handlers)
  withRouter
);



// WEBPACK FOOTER //
// ./src/components/layout/AuthHeader.enhancer.js